
import {IDocumento} from '../interface/IDocumento';
import {CategoriaDocumento} from './CategoriaDocumento';

export class Documento implements IDocumento {

  id: number;
  nombre: string;
  url: string;
  nombreArchivo?: string;
  publicada: boolean;
  categoriaDocumentoId: number;
  categoria?: CategoriaDocumento;
  fecCreacion?: Date;
  fecModificacion?: Date;
  nuevaArchivo?: any;

  constructor(documento: IDocumento) {
    this.id = documento.id;
    this.nombre = documento.nombre;
    this.url = documento.url;
    this.nombreArchivo = documento.nombreArchivo;
    this.publicada = documento.publicada;
    this.categoriaDocumentoId = documento.categoriaDocumentoId;
    if (documento.categoria) {
      this.categoria = documento.categoria;
    }
    this.fecCreacion = documento.fecCreacion;
    this.fecModificacion = documento.fecModificacion;
    if (documento.nuevaArchivo) {
      this.nuevaArchivo = documento.nuevaArchivo;
    }
  }

  getEstado(): string {
    if (this.publicada) {
      return 'Publicada';
    } else {
      return 'No Publicada';
    }
  }

  getFormData(): FormData {
    const formData = new FormData();
    if (this.nombre) {
      formData.append('nombre', this.nombre);
    }
    if (this.publicada && this.publicada === true) {
      formData.append('publicada', '1');
    } else {
      formData.append('publicada', '0');
    }
    if (this.categoriaDocumentoId) {
      formData.append('categoriaDocumentoId', String(this.categoriaDocumentoId));
    }
    console.log('this.nuevaArchivo', this.nuevaArchivo);
    if (this.nuevaArchivo) {
      formData.append('file_upload', this.nuevaArchivo, this.nuevaArchivo.name);
    }
    return formData;
  }
}



// WEBPACK FOOTER //
// /app/src/model/class/Documento.ts